// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comp-chip {
  display: flex;
  gap: 6px;
  padding: 6px 14px 6px 10px;
  background: var(--color-chip-background);
  border: 1px solid var(--color-pages-me-card-border);
  font-size: 14px;
  font-family: Ubuntu-L, sans-serif;
  border-radius: 12px;
  color: var(--color-pages-me-card-text);
  -webkit-user-select: none;
          user-select: none;
}
.comp-chip svg {
  align-self: center;
  font-size: 18px;
}
.comp-chip .chip-text {
  align-self: center;
}`, "",{"version":3,"sources":["webpack://./src/components/chip/chip.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,QAAA;EACA,0BAAA;EACA,wCAAA;EACA,mDAAA;EACA,eAAA;EACA,iCAAA;EACA,mBAAA;EACA,sCAAA;EACA,yBAAA;UAAA,iBAAA;AACF;AACE;EACE,kBAAA;EACA,eAAA;AACJ;AAEE;EACE,kBAAA;AAAJ","sourcesContent":[".comp-chip {\n  display: flex;\n  gap: 6px;\n  padding: 6px 14px 6px 10px;\n  background: var(--color-chip-background);\n  border: 1px solid var(--color-pages-me-card-border);\n  font-size: 14px;\n  font-family: Ubuntu-L, sans-serif;\n  border-radius: 12px;\n  color: var(--color-pages-me-card-text);\n  user-select: none; \n\n  svg {\n    align-self: center;\n    font-size: 18px;\n  }\n\n  .chip-text {\n    align-self: center;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
